<template>
    <div class="card-challenge-leaderboard-first">
        <span class="card-challenge-leaderboard-first__crown-icon"></span>
        <div class="card-challenge-leaderboard-first__wr-img">
            <img class="card-challenge-leaderboard-first__user-img" :src="userImageLink">
            <span class="card-challenge-leaderboard-first__user-img-shadow"></span>
            <span class="card-challenge-leaderboard-first__rank">
                <span class="card-challenge-leaderboard-first__rank-value">{{ leaderboardItem.rank }}</span>
            </span>
        </div>
        <span class="card-challenge-leaderboard-first__username">{{ leaderboardItem.username }}</span>
        <div class="card-challenge-leaderboard-first__stat-win">
            <span class="card-challenge-leaderboard-first__stat-win-value">{{ leaderboardItem.stats.win }}</span>
            <span class="card-challenge-leaderboard-first__stat-win-icon"></span>
        </div>
        <div class="card-challenge-leaderboard-first__stat-loss">
            <span class="card-challenge-leaderboard-first__stat-loss-icon"></span>
            <span class="card-challenge-leaderboard-first__stat-loss-value">{{ leaderboardItem.stats.loss }}</span>
        </div>
        <div class="card-challenge-leaderboard-first__ranking-gem">
            <span class="card-challenge-leaderboard-first__ranking-gem-icon"></span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            leaderboardItem: {
                type: Object,
                default: {
                    id: 4,
                    username: "wololo",
                    rank: 1,
                    stats: {
                        win: 34,
                        loss: 12
                    }
                }
            }
        },

        computed: {
            userImageLink(){
                // return this.$store.state.api.img + this.leaderboardItem.id + '.jpg';
                return this.$store.state.api.getImage + this.leaderboardItem.id;
            },
        },
    };
</script>
<style scoped src="@/css/components/card-challenge-leaderboard-first.css"></style>